module.exports = __webpack_public_path__ + "img/OM.d49c87eb.svg";